/**
 * Objeto api com URL dinâmica baseada no contexto de execução
 * - Client-side (browser): usa NEXT_PUBLIC_BASE_URL (http://localhost:4777)
 * - Server-side (container): usa INTERNAL_API_URL (http://backend:4777)
 */
const api = {
  /**
   * baseURL é um getter que retorna automaticamente a URL correta
   * baseado no contexto (client-side vs server-side)
   */
  get baseURL() {
    // typeof window === 'undefined' significa que está rodando no servidor
    if (typeof window === 'undefined') {
      // Server-side: usa INTERNAL_API_URL (Docker network)
      return process.env.INTERNAL_API_URL || process.env.NEXT_PUBLIC_BASE_URL;
    }
    // Client-side: usa NEXT_PUBLIC_BASE_URL (host network)
    return process.env.NEXT_PUBLIC_BASE_URL;
  },
  // URL interna explícita para casos especiais
  internalURL: process.env.INTERNAL_API_URL || process.env.NEXT_PUBLIC_BASE_URL,
};

export { api };
